module.exports = __webpack_public_path__ + "img/new-relic.9324ec10.png";